module.exports = __webpack_public_path__ + "static/mb-best-promotion-pump-solarcell-f454791d63357c5a757cc38f4deaf623.webp";